// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","Page":"App_Page__xFquV"};